import { TAB } from '../constants';
const getActiveTab = (sections, url) => {
  const activeTabName = url.split('#')[1];
  const isUrlTabValid = !!sections.find(section => section[0] === activeTabName);
  const tabToUse = isUrlTabValid && activeTabName || sections[0][0];
  return `${TAB}-${tabToUse}`;
};
export default getActiveTab;
//# sourceMappingURL=get-active-tab.js.map